export const environment = {
  production: false,
  storage: {
    version: 1,
  },
  api: {
    minVersion: 1.4,
    url: 'https://gate.mhcontrol.net',
    // url: 'https://api.gcs.rootscope.co',
  },
  settings: {
    'MD Bavaria ZA': {
      productionMeterId: ['MD Bavaria ZA.Consumption.SERVIS.$F7'],
      consumptionMeterId: <any>[],
      zoneGroups: [
        {
          name: 'Dashboard',
          dashboard: true,
          zones: ['MD Bavaria ZA.Zone.13'],
          stats: [
            { label: 'Voda', values: [381, 381, 381, 381, 381, 381, 381, 381, 381, 381, 381, 381], units: 'm3' },
            { label: 'Plyn', values: [169255, 125000, 105776, 57565, 47287, 18506, 10877, 12070, 21860, 66380, 109534, 135953], units: 'm3' },
          ],
        },
        {
          name: 'Buildings',
          zones: ['MD Bavaria ZA.Zone.14', 'MD Bavaria ZA.Zone.11'],
        },
        {
          name: 'Workshop',
          zones: [
            'MD Bavaria ZA.Zone.4',
            'MD Bavaria ZA.Zone.5',
            'MD Bavaria ZA.Zone.6',
            'MD Bavaria ZA.Zone.7',
            'MD Bavaria ZA.Zone.8',
            'MD Bavaria ZA.Zone.9',
            'MD Bavaria ZA.Zone.10',
          ],
        },
        {
          name: 'Charging',
          zones: ['MD Bavaria ZA.Zone.3', 'MD Bavaria ZA.Zone.15'],
        },
      ],
    },
    'MD Bavaria TN': {
      productionMeterId: ['MD Bavaria TN.Consumption.BMW GUMY.$02', 'MD Bavaria TN.Consumption.BPS RH.$04'],
      consumptionMeterId: ['MD Bavaria TN.Consumption.BMW GUMY.$01', 'MD Bavaria TN.Consumption.BPS GUMY.$01'],
      zoneGroups: [
        {
          name: 'Dashboard',
          dashboard: true,
          zones: ['MD Bavaria TN.Zone.1'],
          stats: [
            { label: 'Voda', values: [247, 247, 247, 247, 247, 247, 247, 247, 247, 247, 247, 247], units: 'm3' },
            { label: 'Plyn', values: [110016, 81250, 68754, 37417, 30737, 12029, 7070, 7846, 14209, 43147, 71197, 88369], units: 'm3' },
          ],
        },
        {
          name: 'Buildings',
          zones: ['MD Bavaria TN.Zone.2', 'MD Bavaria TN.Zone.3'],
        },
        {
          name: 'Workshop',
          zones: ['MD Bavaria TN.Zone.6', 'MD Bavaria TN.Zone.7', 'MD Bavaria TN.Zone.8'],
        },
        {
          name: 'Charging',
          zones: ['MD Bavaria TN.Zone.4'],
        },
      ],
    },
  },
};
